module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'e0oigsj9',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
